import React from 'react'
import { FacebookBrand, GoHighLevelBrand, LinkedInBrand } from 'blaze-ui/icons/35'
import { TwitterBrand, TikTokBrand, YouTubeBrand, Mailchimp, Wix, GoogleDrive, Shopify, Google } from 'blaze-ui/icons'
import { ZapierLogo } from 'almanac-ui/icons/24'
import WordPressLogo from 'almanac-ui/icons/24/WordPressLogo'
import GoogleAnalytics from 'blaze-ui/icons/20/GoogleAnalytics'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { BrandPlanIntegrations } from 'types'

export interface TacticInfo {
  icon: React.ComponentType
  name: string
  integrationType: ExternalIntegrationEnum
  tactic?: BrandPlanIntegrations
}

export const INTEGRATION_INFO = {
  SHOPIFY: {
    icon: Shopify,
    name: 'Shopify',
    integrationType: ExternalIntegrationEnum.Shopify,
    tactic: 'seo' as const,
  },
  INSTAGRAM: {
    icon: InstagramBrand,
    name: 'Instagram',
    integrationType: ExternalIntegrationEnum.Instagram,
    tactic: 'instagram' as const,
  },
  INSTAGRAM_REELS: {
    icon: InstagramReelsBrand,
    name: 'Instagram Reels',
    integrationType: ExternalIntegrationEnum.Instagram,
    tactic: 'instagram_reel' as const,
  },
  FACEBOOK: {
    icon: FacebookBrand,
    name: 'Facebook',
    integrationType: ExternalIntegrationEnum.Facebook,
    tactic: 'facebook' as const,
  },
  LINKEDIN: {
    icon: LinkedInBrand,
    name: 'LinkedIn',
    integrationType: ExternalIntegrationEnum.LinkedIn,
    tactic: 'linkedin' as const,
  },
  TWITTER: {
    icon: TwitterBrand,
    name: 'X/Twitter',
    integrationType: ExternalIntegrationEnum.X,
    tactic: 'twitter' as const,
  },
  TIKTOK: {
    icon: TikTokBrand,
    name: 'TikTok',
    integrationType: ExternalIntegrationEnum.TikTok,
    tactic: 'tiktok' as const,
  },
  YOUTUBE: {
    icon: YouTubeBrand,
    name: 'YouTube',
    integrationType: ExternalIntegrationEnum.YouTube,
    tactic: 'youtube' as const,
  },
  WORDPRESS: {
    icon: WordPressLogo,
    name: 'WordPress',
    integrationType: ExternalIntegrationEnum.WordPress,
    tactic: 'seo' as const,
  },
  GOHIGHLEVEL: {
    icon: GoHighLevelBrand,
    name: 'GoHighLevel',
    integrationType: ExternalIntegrationEnum.GoHighLevel,
    tactic: 'seo' as const,
  },
  WIX: {
    icon: Wix,
    name: 'Wix',
    integrationType: ExternalIntegrationEnum.Wix,
    tactic: 'seo' as const,
  },
  MAILCHIMP: {
    icon: Mailchimp,
    name: 'Mailchimp',
    integrationType: ExternalIntegrationEnum.Mailchimp,
    tactic: 'email' as const,
  },
  GOOGLE: {
    icon: GoogleAnalytics,
    name: 'Google Analytics',
    integrationType: ExternalIntegrationEnum.Google,
    tactic: 'google' as const,
  },
  GOOGLE_BUSINESS_PROFILE: {
    icon: Google,
    name: 'Google Business Profile',
    integrationType: ExternalIntegrationEnum.GoogleBusinessProfile,
    tactic: 'google_my_business' as const,
  },
  META_ADS: {
    icon: MetaBrand,
    name: 'Meta Ads',
    integrationType: ExternalIntegrationEnum.MetaAds,
  },
  GOOGLE_ADS: {
    icon: Google,
    name: 'Google Ads',
    integrationType: ExternalIntegrationEnum.GoogleAds,
  },
  GOOGLE_DRIVE: {
    icon: GoogleDrive,
    name: 'Google Drive',
    integrationType: ExternalIntegrationEnum.GoogleDrive,
  },
  ZAPIER_BLOG: {
    icon: ZapierLogo,
    name: 'Zapier',
    integrationType: ExternalIntegrationEnum.Zapier,
    tactic: 'seo' as const,
  },
  ZAPIER_EMAIL: {
    icon: ZapierLogo,
    name: 'Zapier',
    integrationType: ExternalIntegrationEnum.Zapier,
    tactic: 'email' as const,
  },
} as const

export const IntegrationNameByProvider: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.X]: 'X / Twitter',
  [ExternalIntegrationEnum.YouTube]: 'YouTube',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.WordPress]: 'WordPress',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.Google]: 'Google Analytics',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
  [ExternalIntegrationEnum.GoogleBusinessProfile]: 'Google Business Profile',
  [ExternalIntegrationEnum.GoogleAds]: 'Google Ads',
  [ExternalIntegrationEnum.GoogleCalendar]: 'Google Calendar',
  [ExternalIntegrationEnum.MicrosoftGraph]: 'Outlook Calendar',
  [ExternalIntegrationEnum.Zapier]: 'Zapier',
}
